import axios from "axios";
import { setSliceState } from "../store/helper"; // Import the helper function
import { BASE_URL } from "./endpoints";

const BASE_HEADERS = {
  "Content-Type": "application/json;charset=utf-8",
};

// Create a shared axios instance with the default baseURL
const apiClient = axios.create({});

// Function to handle request with optional silent mode and baseURL + headers override
const handleRequest = async (method, url, data = null, options = {}) => {
  const { silent = false, baseURL = BASE_URL, headers = {} } = options; // Default to BASE_URL and empty headers

  try {
    if (!silent) {
      setSliceState("api", { loading: true }); // Set loading state
      setSliceState("api", { error: null }); // Clear error state
    }

    // Create the request configuration object
    const config = {
      method,
      url,
      data,
      baseURL, // Override baseURL if provided
      headers: {
        ...BASE_HEADERS, // Get common default headers from apiClient
        ...headers, // Merge with custom headers from options
      },
    };

    const response = await axios(config); // Use the merged config for the request

    if (!silent) {
      setSliceState("api", { loading: false }); // Reset loading state
    }

    return response;
  } catch (error) {
    if (!silent) {
      setSliceState("api", { loading: false }); // Reset loading state
      setSliceState("api", { error: error.message }); // Set error state
    }
    throw error; // Rethrow the error for further handling
  }
};

// Export functions for get, post, put, delete with silent control and baseURL override
export const apiGet = (url, options = {}) =>
  handleRequest("get", url, null, options);
export const apiPost = (url, data, options = {}) =>
  handleRequest("post", url, data, options);
export const apiPut = (url, data, options = {}) =>
  handleRequest("put", url, data, options);
export const apiDelete = (url, options = {}) =>
  handleRequest("delete", url, null, options);

export default apiClient;
